import '../../css/pages/before-after.css';
import { initShell } from '../lib/shell';

initShell();

// ---- Per-slide drag-to-reveal slider -------------------------------------
// Returns a re-apply function per card so the carousel below can recompute
// sizing when a slide switches from display:none to visible (an element
// hidden with display:none reports clientWidth 0, so the reveal width set
// while it was inactive would otherwise be wrong once it's shown again).
const sliderApply = new Map<HTMLElement, () => void>();

document.querySelectorAll<HTMLElement>('[data-component="ba-slider"]').forEach((card) => {
  const slider = card.querySelector<HTMLElement>('.ba-card__slider');
  const clip = card.querySelector<HTMLElement>('.ba-card__clip');
  const clipImg = clip?.querySelector<HTMLImageElement>('.ba-card__img');
  const handle = card.querySelector<HTMLElement>('.ba-card__handle');
  const range = card.querySelector<HTMLInputElement>('.ba-card__range');
  if (!slider || !clip || !clipImg || !handle || !range) return;

  function apply(): void {
    const percent = Number(range!.value);
    const w = slider!.clientWidth;
    clip!.style.width = percent + '%';
    if (w > 0) clipImg!.style.width = w + 'px';
    handle!.style.left = percent + '%';
  }

  apply();
  range.addEventListener('input', apply);
  window.addEventListener('resize', apply);
  sliderApply.set(card, apply);
});

// ---- Carousel: prev/next + dots -------------------------------------------
document.querySelectorAll<HTMLElement>('[data-component="ba-carousel"]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll<HTMLElement>('[data-component="ba-slider"]'));
  const prevBtn = carousel.querySelector<HTMLButtonElement>('[data-role="prev"]');
  const nextBtn = carousel.querySelector<HTMLButtonElement>('[data-role="next"]');
  const dots = Array.from(carousel.querySelectorAll<HTMLButtonElement>('[data-role="dot"]'));
  if (slides.length === 0) return;

  let current = slides.findIndex((s) => s.classList.contains('is-active'));
  if (current < 0) current = 0;

  function goTo(index: number): void {
    const next = (index + slides.length) % slides.length;
    if (next === current) return;
    slides[current]?.classList.remove('is-active');
    dots[current]?.classList.remove('is-active');
    current = next;
    slides[current]?.classList.add('is-active');
    dots[current]?.classList.add('is-active');
    // Now that this slide is visible again, recompute its reveal sizing.
    sliderApply.get(slides[current])?.();
  }

  prevBtn?.addEventListener('click', () => goTo(current - 1));
  nextBtn?.addEventListener('click', () => goTo(current + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
});
